import React, { Component } from 'react';
import ReviewList from './reviews/ReviewList';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ButtonStrap from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Link from 'react-router-dom/Link';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
//import { v4 as uuidv4 } from 'uuid';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

class SoftwareReviews extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSliderChange1 = this.handleSliderChange1.bind(this);
    this.handleSliderChange2 = this.handleSliderChange2.bind(this);
    this.handleSliderChange3 = this.handleSliderChange3.bind(this);
    this.handleSliderChange4 = this.handleSliderChange4.bind(this);
    this.handleSliderChange5 = this.handleSliderChange5.bind(this);
    this.showInvalidAlert = this.showInvalidAlert.bind(this);
    this.handleReviewSubmit = this.handleReviewSubmit.bind(this);
    this.calculateReviewScore = this.calculateReviewScore.bind(this);
    this.generateReviewButton = this.generateReviewButton.bind(this);

    this.db = firebase.firestore();
    this.ref = this.db
      .collection('software_pages')
      .doc(this.props.match.params.id);
    this.usersRef = this.db.collection('user_accounts');

    this.state = {
      accType: '',
      showModal: false,
      revUseTime: 'Just started using it',
      revScore1: 3,
      revScore2: 3,
      revScore3: 3,
      revScore4: 3,
      revScore5: 3,
      revTitle: '',
      revDetails: '',
      revFeedback: '',
      revCreatedBy: '',
      userEmail: '',
      userReviews: [],
      prodId: this.props.match.params.id,
      showAlert: false,
      alertText: [],
      reviews: [],
      alreadyReviewed: false,
      loading: true,
      loggedIn: false,
    };
  }

  componentDidMount() {
    let _this = this;
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        _this.setState({
          revCreatedBy: user.displayName,
          userEmail: user.email,
          accType: user.photoURL,
          loggedIn: true,
        });
        _this.usersRef
          .doc(user.email)
          .get()
          .then(doc => {
            if (doc.exists) {
              let docData = doc.data();
              _this.setState({ userReviews: docData.reviews });
            }

            // Check if the user has already reviewed it
            _this.state.userReviews.forEach(id => {
              if (id.includes(_this.state.prodId)) {
                _this.setState({ alreadyReviewed: true });
              }
            });
            // Load in all the current reviews
            let _reviews = [];
            _this.ref
              .collection('reviews')
              .limit(20)
              .get()
              .then(query => {
                query.forEach(doc => {
                  _reviews = _reviews.concat(doc.data());
                });
                // Always udpate state in THEN after the data has been loaded
                _this.setState({ reviews: _reviews });

                // Done loading
                _this.setState({ loading: false });
              });
          });
      } else {
        // NO user exists
        // TODO: Add to redirect page
        _this.setState({ loggedIn: false });
      }
    });
  }

  handleReviewSubmit(event) {
    event.preventDefault();
    let alertNeeded = false,
      alerts = [];

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      console.log('Form not valid!');
      event.stopPropogation();
      alertNeeded = true;
      alerts = alerts.concat('Please make sure all the inputs are filled');
      return;
    }

    let _this = this;
    // So its id can be retrieved
    const newRef = this.ref.collection('reviews').doc();

    let revModel = {
      revId: newRef.id,
      revUseTime: this.state.revUseTime,
      revScore1: this.state.revScore1,
      revScore2: this.state.revScore2,
      revScore3: this.state.revScore3,
      revScore4: this.state.revScore4,
      revScore5: this.state.revScore5,
      revTitle: this.state.revTitle,
      revDetails: this.state.revDetails,
      revFeedback: this.state.revFeedback,
      revRating: this.calculateReviewScore(),
      revCreatedBy: this.state.revCreatedBy,
      userLikes: [],
      softies: 0,
      revDate: firebase.firestore.Timestamp.fromDate(new Date()),
    };

    newRef
      .set(revModel)
      .then(resut => {
        // Then add the reviews to the user's review list
        _this.usersRef
          .doc(_this.state.userEmail)
          .update({
            reviews: _this.state.userReviews.concat(
              _this.state.prodId + '/' + newRef.id
            ),
          })
          .then(result => {
            // Update the product's overall rating
            _this.ref
              .update({
                reviewCount: firebase.firestore.FieldValue.increment(1),
                reviewTotal: firebase.firestore.FieldValue.increment(
                  parseFloat(revModel.revRating)
                ),
              })
              .then(result => {
                // Finally, hide the modal
                _this.setState({
                  showModal: false,
                  reviews: _this.state.reviews.concat(revModel),
                });
              });
          });
      })
      .catch(err => console.log('Error in uploading document: ', err));

    if (alertNeeded) {
      this.setState({ showAlert: true, alertText: alert });
    }
  }

  calculateReviewScore() {
    let sum =
      this.state.revScore1 +
      this.state.revScore2 +
      this.state.revScore3 +
      this.state.revScore4 +
      this.state.revScore5;
    return ((sum / 25) * 6.0).toFixed(2);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  handleSliderChange1(revScore1) {
    this.setState({ revScore1, showAlert: false });
  }
  handleSliderChange2(revScore2) {
    this.setState({ revScore2, showAlert: false });
  }
  handleSliderChange3(revScore3) {
    this.setState({ revScore3, showAlert: false });
  }
  handleSliderChange4(revScore4) {
    this.setState({ revScore4, showAlert: false });
  }
  handleSliderChange5(revScore5) {
    this.setState({ revScore5, showAlert: false });
  }

  showInvalidAlert() {
    if (this.state.showAlert) {
      return (
        <Alert variant="warning">
          <Alert.Heading> Please fix the following problems: </Alert.Heading>
          <ul>
            {this.state.alertText.map(alertText => (
              <li> {alertText} </li>
            ))}
          </ul>
        </Alert>
      );
    } else {
      return <div></div>;
    }
  }

  generateReviewButton() {
    if (!this.state.loggedIn) {
      return (
        <Alert variant="danger">
          {' '}
          You need to be logged in to post a review!{' '}
        </Alert>
      );
    }
    if (this.state.accType === 'developer') return <div></div>;
    return this.state.alreadyReviewed ? (
      <p style={{ margin: '0px 0px 8px 5px' }}>
        {' '}
        Awesome, you've already reviewed it and helped others!
        <Link to="/my_account"> Go to your account see it. </Link>
      </p>
    ) : (
      <Button
        variant="link"
        style={{ margin: '0px 0px 5px -5px' }}
        onClick={() => this.setState({ showModal: true })}
      >
        Add your own review!
      </Button>
    );
  }

  render() {
    if (this.state.loading && this.state.loggedIn) return null;
    return (
      <div className="container">
        <this.generateReviewButton />
        <Alert variant={'warning'}>
          Product Reviews
        </Alert>
        <ReviewList
          reviews={this.state.reviews}
          prodId={this.state.prodId}
          userEmail={this.state.userEmail}
        />
        <Modal
          size="lg"
          centered
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Leave a review</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form onSubmit={this.handleReviewSubmit}>
                <h6>
                  {' '}
                  Make your review objective by providing honest feedback
                </h6>
                <this.showInvalidAlert />
                <p style={{ margin: '0px 0px 0px 3px', fontStyle: 'italic' }}>
                  For sliders, use a scale of 1 - 5 where 1 represents complete
                  disagreement and 5 represents complete agreement.
                </p>
                <br />
                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>How long have you used it?</Form.Label>
                  <Form.Control
                    as="select"
                    name="revUseTime"
                    onChange={this.handleChange}
                  >
                    <option>Just started using it</option>
                    <option>A little here and there</option>
                    <option>Considerable time</option>
                    <option>Adept at it</option>
                  </Form.Control>
                </Form.Group>

                {/* Sliders */}
                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>
                    {' '}
                    The product did what it intended to do:{' '}
                  </Form.Label>
                  <Slider
                    name="revScore1"
                    onChange={this.handleSliderChange1}
                    dots
                    min={1}
                    max={5}
                    step={1}
                    defaultValue={3}
                    marks={{
                      1: '1',
                      2: '2',
                      3: '3',
                      4: '4',
                      5: '5',
                    }}
                    style={{ width: '95%', margin: '15px 15px 30px 15px' }}
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>
                    {' '}
                    The product was relatively easy to use and the instructions
                    were clear:{' '}
                  </Form.Label>
                  <Slider
                    name="revScore2"
                    onChange={this.handleSliderChange2}
                    dots
                    min={1}
                    max={5}
                    step={1}
                    defaultValue={3}
                    marks={{
                      1: '1',
                      2: '2',
                      3: '3',
                      4: '4',
                      5: '5',
                    }}
                    style={{ width: '95%', margin: '15px 15px 30px 15px' }}
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>
                    {' '}
                    Either through contacting the developers, browsing the
                    documentation, or interacting the community, I was able to
                    resolve any problems I faced:{' '}
                  </Form.Label>
                  <Slider
                    name="revScore3"
                    onChange={this.handleSliderChange3}
                    dots
                    min={1}
                    max={5}
                    step={1}
                    defaultValue={3}
                    marks={{
                      1: '1',
                      2: '2',
                      3: '3',
                      4: '4',
                      5: '5',
                    }}
                    style={{ width: '95%', margin: '15px 15px 30px 15px' }}
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>
                    {' '}
                    There were minmal or no bugs/glitches present in the
                    product:{' '}
                  </Form.Label>
                  <Slider
                    name="revScore4"
                    onChange={this.handleSliderChange4}
                    dots
                    min={1}
                    max={5}
                    step={1}
                    defaultValue={3}
                    marks={{
                      1: '1',
                      2: '2',
                      3: '3',
                      4: '4',
                      5: '5',
                    }}
                    style={{ width: '95%', margin: '15px 15px 30px 15px' }}
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>
                    {' '}
                    The user interface (UI) was well designed and easy to
                    navigate:{' '}
                  </Form.Label>
                  <Slider
                    name="revScore5"
                    onChange={this.handleSliderChange5}
                    dots
                    min={1}
                    max={5}
                    step={1}
                    defaultValue={3}
                    marks={{
                      1: '1',
                      2: '2',
                      3: '3',
                      4: '4',
                      5: '5',
                    }}
                    style={{ width: '95%', margin: '15px 15px 30px 15px' }}
                  />
                </Form.Group>

                <br />
                <Form.Group controlId="formProductName">
                  <Form.Label> Overall impression in a few words</Form.Label>
                  <Form.Control
                    required
                    maxLength="35"
                    name="revTitle"
                    onChange={this.handleChange}
                    type="name"
                    placeholder="The title of your review"
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlTextarea2">
                  <Form.Label>
                    {' '}
                    Describe your experience in words or elaborate on why you
                    gave the ratings above (does not affect your rating score)
                  </Form.Label>
                  <Form.Control
                    required
                    maxLength="200"
                    as="textarea"
                    rows="3"
                    name="revDetails"
                    onChange={this.handleChange}
                    placeholder="Enter details about the app: why it is useful and what it does"
                  />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlTextarea3">
                  <Form.Label>
                    {' '}
                    Any feedback for the devs? They will appreciate it!
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    maxLength="200"
                    rows="3"
                    name="revFeedback"
                    onChange={this.handleChange}
                    placeholder="Enter details about the app: why it is useful and what it does"
                  />
                </Form.Group>

                <Form.Group controlId="formBasicCheckbox">
                  <Form.Check
                    required
                    type="checkbox"
                    label="I have used the product myself and am submitting an honest review based on my experience. Submitting inaccurate information or not confirming with the policies may result in account suspension or a ban."
                  />
                </Form.Group>

                <Modal.Footer>
                  <ButtonStrap
                    variant="secondary"
                    onClick={() => this.setState({ showModal: false })}
                  >
                    Close
                  </ButtonStrap>
                  <ButtonStrap variant="primary" type="submit">
                    Create Review
                  </ButtonStrap>
                </Modal.Footer>
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default SoftwareReviews;
